import { AvatarUser } from "@pathwright/ux/src/components/avatar/types"
import { Author as CoverPageContributor } from "@pathwright/graphql-client/src/generated"

export type ContributorAvatarSource = Pick<
  CoverPageContributor,
  "id" | "first_name" | "last_name" | "display_name" | "avatar" | "image"
>

export const normalizeBio = (bio?: string | null) => bio || ""

export const getAvatarUserFromContributor = (
  contributor: ContributorAvatarSource
): AvatarUser => {
  return {
    id: contributor.id,
    first_name: contributor.first_name,
    last_name: contributor.last_name,
    full_name: contributor.display_name,
    profile: {
      image: contributor.avatar || contributor.image
    }
  } as AvatarUser
}
